export default "__VITE_ASSET__CDbY7FDm__"